import script from "./FadeTransition.vue?vue&type=script&setup=true&lang=js"
export * from "./FadeTransition.vue?vue&type=script&setup=true&lang=js"

import "./FadeTransition.vue?vue&type=style&index=0&id=23bfbd92&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23bfbd92"]])

export default __exports__